import { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/authStore'

interface RouteGuardProps {
  children: React.ReactNode
}

export const RouteGuard = ({ children }: RouteGuardProps) => {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuthStore((state) => state.auth)

  useEffect(() => {
    if (!isAuthenticated()) {
      const currentPath = window.location.pathname
      // Don't redirect to sign-in if already on sign-in page
      if (currentPath !== '/sign-in') {
        navigate({ to: '/sign-in', search: { redirect: currentPath } })
      }
    }
  }, [isAuthenticated, navigate])

  if (!isAuthenticated) {
    return null
  }

  return <>{children}</>
} 